<template>
  <div
    class="slide fp-noscroll"
    :class="{ full: fullscreen }"
    :style="
      fullscreen
        ? `background-image: url(${photo});`
        : slide.backgroundColor
        ? `background-color: ${slide.backgroundColor};`
        : ''
    "
    @click="openLightbox"
  >
    <Loading v-if="isLoading"></Loading>
    <div
      class="bg-full"
      :style="`background-image: url(${photo})`"
      v-if="!fullscreen && !slide.backgroundColor"
    ></div>
    <picture v-show="!fullscreen">
      <img :src="photo" alt="" style="width: auto" @load="onImgLoad" />
    </picture>
    <app-footer :footer="slide.footnote" :details="slide.details"></app-footer>
  </div>
</template>

<script>
import AppFooter from "./Footer";
import Loading from "./Loading.vue";
import loaderLoaderMixin from "../mixins/loader";

export default {
  props: ["slide", "photo", "footnote", "details", "fullscreen"],
  mixins: [loaderLoaderMixin],
  components: { AppFooter, Loading },
  methods: {
    onImgLoad() {
      this.isLoading = false;
    },
    openLightbox() {
      console.log("Open Lightbox");
      this.$emit("openLightbox", {
        photos: [
          {
            url: this.photo,
          },
        ],
        index: 0,
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.slide {
  position: relative;
}
picture {
  position: relative;
  z-index: 100;
}
picture img {
  max-width: 100%;
  max-height: 100%;
}
.bg-full {
  position: absolute;
  z-index: 90;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.5;
  filter: blur(35px);
}
.full {
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
